import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { TournamentsService } from './../tournaments/services/tournaments.service';
import { translationHelper } from '~/helpers/translation.helper';

declare let $;

declare let JsBarcode: any;

declare let SetLanguage: any;
@Component({
    selector: 'comp_read_payout',
    templateUrl: './readPayout_modal.html',
})
export class ReadPayoutModal implements OnInit {
    constructor(public tournamentsService: TournamentsService, private _translate: translationHelper) {
        SetLanguage('', '');
    }
    init: boolean;
    ngOnInit() {
        SetLanguage('', '');
        if (this.init) return;
        this.init = true;
    }

    ReadPayoutSlip_ChangeValue(e) {
        if (this.tournamentsService.ReadPayoutSlipFocusControl == 1) {
            this.tournamentsService.PayoutSlipNumber += e;
        }
        if (this.tournamentsService.ReadPayoutSlipFocusControl == 2) {
            this.tournamentsService.PayoutSlipPassword += e;
        }
    }
    ReadPayoutSlipOk() {
        if (this.tournamentsService.PayoutSlipNumber != '' && this.tournamentsService.PayoutSlipPassword != '') {
            this.tournamentsService.payoutSlipPay($('input[name="__RequestVerificationToken"]').val());
        } else {
            this.tournamentsService.readPayoutErrorVisible = 1;
            this.tournamentsService.readPayoutError = this._translate.getT('Enter_all_fields');
        }
    }
    ReadPayoutSlip__Cancel() {
        if (this.tournamentsService.ReadPayoutSlipFocusControl == 1) {
            this.tournamentsService.PayoutSlipNumber = this.tournamentsService.PayoutSlipNumber.slice(0, -1);
        }
        if (this.tournamentsService.ReadPayoutSlipFocusControl == 2) {
            this.tournamentsService.PayoutSlipPassword = this.tournamentsService.PayoutSlipPassword.slice(0, -1);
        }
    }
    ReadPayoutSlip_Close() {
        this.tournamentsService.PayoutSlipNumber = '';
        this.tournamentsService.PayoutSlipPassword = '';
        $('#ReadPayoutSlip').modal('hide');
        this.tournamentsService.payoutPayConfirmButton = 0;
    }
    ReadPayoutSlip_TicketNumber() {
        this.tournamentsService.ReadPayoutSlipFocusControl = 1;
    }
    ReadPayoutSlip_TicketPassword() {
        this.tournamentsService.ReadPayoutSlipFocusControl = 2;
    }
    PayoutDetailModal_Exit() {
        $('#PayoutDetailModal').modal('hide');
        this.tournamentsService.PayoutPayConfirmVisible = 0;
        this.tournamentsService.PayoutSlipPassword = '';
        this.tournamentsService.PayoutSlipNumber = '';
        this.tournamentsService.payoutPayConfirmButton = 0;
    }
    Payout_Detail_Pay(CurrencyId, Amount, SlipId) {
        // Open Setting Modal
        this.tournamentsService.PayoutSlipPay_Confirm(
            $('input[name="__RequestVerificationToken"]').val(),
            Amount,
            CurrencyId,
            SlipId,
        );
        //$('#settings_Modal_2')
        //  .modal('setting', 'closable', false)
        //  .modal('show')
        //  ;
    }
}
